import type { AxiosResponse } from 'axios';
import { appAxios } from 'utils/appAxios';
import { organizationUsersApi } from './api';

export type OrganizationUsersPermittedServicesType = Required<{
  quest: boolean;
  competition: boolean;
  dxCopilotPlanner: boolean;
  dxCopilotAnalytics: boolean;
}>;

export type OrganizationUsersMeResponse = Required<{
  id: number;
  status: 'pending' | 'active' | 'inactive';
  name: string | null;
  userId: number | null;
  speciality: 'information_technical' | 'technical' | 'non_technical' | null;
  jobCategory: string | null;
  dataAnalysisExperience: string | null;
  iconImageUrl: string | null;
  identicon: string;
  logoUrl: string | null;
  permittedServices: OrganizationUsersPermittedServicesType;
}>;

export type OrganizationUsersMeRequest = Required<{
  name: string;
  speciality: 'information_technical' | 'technical' | 'non_technical';
  jobCategory: string;
  dataAnalysisExperience: string;
  icon: File | null;
}>;

export const getOrganizationUsersMe = async (): Promise<AxiosResponse> => {
  return await appAxios.get(`${organizationUsersApi.path}/me`);
};

export const getOrganizationUsersMeSpecialNotes =
  async (): Promise<AxiosResponse> => {
    return await appAxios.get(`${organizationUsersApi.path}/me/special_notes`);
  };
export const getOrganizationUsersMeLicenses =
  async (): Promise<AxiosResponse> => {
    return await appAxios.get(`${organizationUsersApi.path}/me/licenses`);
  };

export const putOrganizationUsersMe = async (
  form: OrganizationUsersMeRequest
): Promise<AxiosResponse> => {
  const formData = new FormData();
  formData.append('name', form.name);
  formData.append('speciality', form.speciality);
  formData.append('job_category', form.jobCategory);
  formData.append('data_analysis_experience', form.dataAnalysisExperience);
  if (form.icon === null) {
    formData.append('delete_icon', 'true');
  } else {
    formData.append('delete_icon', 'false');
    if (form.icon) {
      formData.append('icon', form.icon, form.icon.name);
    }
  }
  formData.append('_method', 'PUT');

  return await appAxios.put(`${organizationUsersApi.path}/me`, formData);
};
